/* @flow */
import axios from 'axios'
import oPath from 'object-path'

import {computePaginateSortFilterParams, computedCollectionCount} from '@/utils/api'
import {NEW_NOTIFICATION} from './notifications'

export const FETCH_END_DEVICE_JOIN_REQS = 'FETCH_END_DEVICE_JOIN_REQS'
export const FETCH_GATEWAY_JOIN_REQS = 'FETCH_GATEWAY_JOIN_REQS'
export const FETCH_APPLICATION_NETWORK_JOIN_REQS = 'FETCH_APPLICATION_NETWORK_JOIN_REQS'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    [FETCH_END_DEVICE_JOIN_REQS]: async function({dispatch}: Object, payload: Object) {
      try {
        const {data} = await axios.get(
          `/end_devices/${payload.context.endDeviceEui}/join_requests`,
          {
            params: computePaginateSortFilterParams(payload),
          }
        )

        const {pagination} = data.meta
        return {
          success: true,
          // Return fetched data as flat array
          items: data.data.map(item => item.attributes),
          collectionCount: computedCollectionCount({
            endRow: payload.endRow,
            filteredCount: pagination.filtered_count,
            collectionCount: pagination.collection_count,
          }),
        }
      } catch (err) {
        if (oPath.get(err, 'response.status') !== 404) {
          dispatch(NEW_NOTIFICATION, {
            text: 'Failed to load join requests ',
            detail: err.message,
            color: 'error',
          })
        }
      }
      return {success: false}
    },
    [FETCH_GATEWAY_JOIN_REQS]: async function({dispatch}: Object, payload: Object) {
      try {
        const {data} = await axios.get(
          `/gateways/${payload.context.gatewayEui}/join_requests`,
          {
            params: computePaginateSortFilterParams(payload),
          }
        )

        const {pagination} = data.meta
        return {
          success: true,
          // Return fetched data as flat array
          items: data.data.map(item => item.attributes),
          collectionCount: computedCollectionCount({
            endRow: payload.endRow,
            filteredCount: pagination.filtered_count,
            collectionCount: pagination.collection_count,
          }),
        }
      } catch (err) {
        if (oPath.get(err, 'response.status') !== 404) {
          dispatch(NEW_NOTIFICATION, {
            text: 'Failed to load join requests ',
            detail: err.message,
            color: 'error',
          })
        }
      }
      return {success: false}
    },
    [FETCH_APPLICATION_NETWORK_JOIN_REQS]: async function(
      {dispatch}: Object,
      payload: Object
    ) {
      try {
        const {data} = await axios.get(
          `/application_networks/${payload.context.appEui}/join_requests`,
          {
            params: computePaginateSortFilterParams(payload),
          }
        )

        const {pagination} = data.meta
        return {
          success: true,
          // Return fetched data as flat array
          items: data.data.map(item => item.attributes),
          collectionCount: computedCollectionCount({
            endRow: payload.endRow,
            filteredCount: pagination.filtered_count,
            collectionCount: pagination.collection_count,
          }),
        }
      } catch (err) {
        if (oPath.get(err, 'response.status') !== 404) {
          dispatch(NEW_NOTIFICATION, {
            text: 'Failed to load join requests ',
            detail: err.message,
            color: 'error',
          })
        }
      }
      return {success: false}
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/join_requests.js